import { useState, useEffect, useRef, Fragment } from "react";
import { useParams, useHistory } from "react-router-dom";
import { API_URL, scroll, getValFromLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";
import Notice from "../../components/Notice";
import Input from "../../components/Input";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Nav from "../Nav";

const Confirmed = () => {
  const [user, setUser] = useState({});
  const [details, setDetails] = useState({});
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({});
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const { str } = useParams();
  const formElement = useRef();
  const history = useHistory();

  useEffect(() => {
    const init = async () => {
      const auth = getValFromLS("dash", true)
        ? JSON.parse(getValFromLS("dash", true))
        : {};
      const url = new URL(`${API_URL}/dashboardHotelEditInit`);
      const params = {
        id: auth.id ? auth.id : "",
        q: str ? str : "",
      };
      url.search = new URLSearchParams(params);

      try {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });
        const json = await response.json();
        if (json && json.resp === 1) {
          setUser({ ...JSON.parse(getValFromLS("dash", true)) });

          setDetails({
            ...json,
          });

          setNames((names) => ({
            ...names,
            name: json.name,
            email: json.email,
          }));

          setAlert({});
          scroll();
        } else {
          setAlert({
            type: json.resp === 2 ? "notice" : "error",
            text: json.text,
          });
        }
      } catch (error) {
        setAlert({
          type: "error",
          text: "An error has occurred.",
        });
      }
    };

    init();

    // eslint-disable-next-line
  }, []);

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/dashboardHotelConfirmed`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append("roomId", details.roomId);
    data.append("auth", getValFromLS("dash", true));
    data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        history.push({
          pathname: `/dashboard/hotel`,
          state: {
            message: {
              type: "success",
              text: json.text,
            },
          },
        });
      } else if (json && json.resp === 2) {
        history.push({
          pathname: `/dashboard/hotel`,
        });
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <>
          <div id="left-column">
            <Hdg section="Sponsor Dashboard" />

            {details.pendingChanges.length > 0 && (
              <Notice
                data={{
                  type: "notice",
                  text: "There is a pending name change for this request.",
                }}
              />
            )}

            <p>
              Use this form to edit an occupant’s name for a confirmed request.
            </p>

            <table
              className="approved assigned"
              style={{ marginTop: "15px", marginBottom: "15px" }}
            >
              <thead>
                <tr>
                  <th className="center" style={{ width: "15%" }}>
                    ID
                  </th>
                  <th className="center" style={{ width: "30%" }}>
                    Hotel / Room
                  </th>
                  <th className="center">Occupant</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="center">{details.roomId}</td>
                  <td className="center">{`${details.hotel} / ${details.room}`}</td>
                  <td className="center">{`${details.name} (${details.email})`}</td>
                </tr>
              </tbody>
            </table>

            <div className="spacer"></div>

            <form
              ref={formElement}
              method="post"
              action="/"
              onSubmit={(e) => handleSubmit(e)}
              className="well"
            >
              <h4
                style={{
                  marginTop: "0",
                  lineHeight: "22px",
                  marginBottom: "10px",
                  fontSize: "1.1rem",
                }}
              >
                Edit Occupant Name
              </h4>

              {details.pendingChanges.length > 0 && (
                <table
                  className="approved assigned"
                  style={{ marginTop: "15px", marginBottom: "15px" }}
                >
                  <thead>
                    <tr>
                      <th className="center" style={{ width: "16%" }}>
                        Date
                      </th>
                      <th className="center" style={{ width: "42%" }}>
                        Old Name
                      </th>
                      <th className="center" style={{ width: "42%" }}>
                        New Name
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {details.pendingChanges.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td className="center">{item.date}</td>
                          <td className="center">{item.old}</td>
                          <td className="center">{item.new}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}

              <div className="form-group">
                <Input
                  name="name"
                  label="Name"
                  reqd={true}
                  value={names.name}
                  autocomplete="off"
                  update={handleUpdate}
                  errors={errors}
                />

                <div className="empty" />

                {/*<Input
                  name="email"
                  label="Email"
                  reqd={true}
                  value={names.email}
                  autocomplete="off"
                  update={handleUpdate}
                  errors={errors}
              />*/}
              </div>

              <div className="msg-submit">
                {msg.type && <Msg data={msg} />}

                <div
                  className={
                    msg.type === "working" || msg.type === "success"
                      ? "hidden"
                      : "submit-container"
                  }
                >
                  <Submit
                    path="/dashboard/hotel"
                    left="Back"
                    submit="Edit Occupant"
                  />
                </div>
              </div>
            </form>

            <div className="spacer"></div>
          </div>

          <div id="right-column">
            <Nav on={0} user={user} />
          </div>
        </>
      )}
    </>
  );
};

export default Confirmed;
